import React from 'react';

const PersonSchema = () => {
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "Person",
        "name": "Peter Sloboda",
        "alternateName": "Peťo Sloboda",
        "description": "Toto je Peter Sloboda, autor knihy Renta bez dátumu spotreby, najdete ho taky na LinkedInu (https://www.linkedin.com/in/petosloboda/), Instagramu (https://www.instagram.com/petosloboda/), YouTube (https://www.youtube.com/@peto.sloboda).",
        "url": "https://petosloboda.sk",
        "sameAs": [
            "https://www.linkedin.com/in/petosloboda/",
            "https://www.instagram.com/petosloboda/",
            "https://www.youtube.com/@peto.sloboda"
        ],
        "jobTitle": "Architekt majetku",
        "author": {
            "@type": "Book",
            "name": "Renta bez dátumu spotreby"
        }
    };

    return (
        <script type="application/ld+json">
            {JSON.stringify(schemaData)}
        </script>
    );
};

export default PersonSchema;
